import { useMemo } from 'react';
import { EditableFormTemplate, FieldWithGroupSlug } from '../types';

export const useGetAllFieldsWithGroupSlugs = (
  formTemplate?: EditableFormTemplate,
): FieldWithGroupSlug[] | undefined =>
  useMemo(
    () =>
      formTemplate?.groups.flatMap((group) =>
        group.fields.map((field) => ({ field, groupSlug: group.slug })),
      ),
    [formTemplate],
  );
